import React from "react";
import { BrowserRouter } from "react-router-dom";
import { useAuth } from "../features/auth/hooks/useAuth.js";
import { LoginPage } from "../features/auth/pages/LoginPage.jsx";
import { AppShell } from "./routes.jsx";
import { ThemeProvider } from "../shared/context/ThemeContext.jsx";
import { ConfigProvider, useConfig } from "../shared/context/ConfigContext.jsx";
import { DangerConfirmProvider } from "../shared/context/DangerConfirmContext.jsx";
import { ActiveCompanyProvider } from "../shared/context/ActiveCompanyContext.jsx";

export function AppContent() {
  const { user, loading, logout } = useAuth();
  const config = useConfig();

  if (loading) {
    return (
      <div style={{
        minHeight: "100dvh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--bg-app)",
        color: "var(--text-muted)"
      }}>
        <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>{config?.branding?.appLogo || "📚"}</div>
        <div style={{ fontSize: "1rem", fontWeight: "600" }}>Loading {config?.name || "Books App"}...</div>
      </div>
    );
  }

  if (!user) {
    return <LoginPage onLoginSuccess={() => {}} />;
  }

  return (
    <DangerConfirmProvider>
      <ActiveCompanyProvider>
        <AppShell user={user} onLogout={logout} />
      </ActiveCompanyProvider>
    </DangerConfirmProvider>
  );
}

export function App() {
  return (
    <ConfigProvider>
      <ThemeProvider>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </ThemeProvider>
    </ConfigProvider>
  );
}

export default App;

